// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  BUTTON_FOCUSED_COLOR,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_NORMAL_PP,
  HIGH_CONTRAST_TEXT_COLOR,
  PRIMARY_COLOR_V2,
  WARNING_COLOR,
  WARNING_MESSAGE_BACKGROUND_COLOR,
  WHITE_COLOR,
} from '@/styles/styleVariables';

const logInButtonStyleOverrides = css`
  align-items: center;
  background-color: ${BUTTON_FOCUSED_COLOR};
  border-radius: 16px;
  color: ${WHITE_COLOR};
  display: flex;
  flex: none;
  flex-grow: 0;
  font-size: 14px;
  height: 32px;
  justify-content: center;
  min-width: 78px;
  order: 1;
  padding: 0 16px;
  width: auto;

  &:focus {
    background-color: ${BUTTON_FOCUSED_COLOR};
    border-color: ${PRIMARY_COLOR_V2};
    box-shadow:
      0 0 0 0.125rem ${PRIMARY_COLOR_V2} inset,
      0 0 0 0.375rem rgb(16 114 235 / 16%);
    text-decoration: none;
  }

  &:hover {
    background-color: ${PRIMARY_COLOR_V2};
    text-decoration: none;
  }
`;

const nonBaslLinkStyles = css`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  margin-bottom: 23.5px;
  text-align: center;

  a {
    font-weight: 700;
  }
`;

const pageWarningContainerStyles = css`
  background-color: ${WARNING_MESSAGE_BACKGROUND_COLOR};
  border: 1px solid ${WARNING_COLOR};
  display: flex;
  margin-bottom: 15px;
  padding: 10px;
`;

const BaslApplePayLinkStyles = css`
  margin-top: 23.5px;
  margin-bottom: 23.5px;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
  color: #2b2e2f;
`;

export {
  BaslApplePayLinkStyles,
  nonBaslLinkStyles,
  logInButtonStyleOverrides,
  pageWarningContainerStyles,
};
